import { gql } from '@apollo/client'

export const GET_CUSTOMER_ID_FOR_MEMBER_CREATION = gql`
  query ($documentNumber: ID!) {
    customer(documentNumber: $documentNumber) {
      origin {
        originId
        channel
        identifier
      }
      additionalName
      address {
        addressLocality
        addressRegion
        addressNumber
        complement
        district
        postalCode
        streetAddress
      }
      birthDate
      documentNumber
      documentType
      email
      familyName
      gender
      givenName
      nationality
      nickName
      status
      whatsapp
    }
  }
`

const GET_CUSTOMER_ID = gql`
  query ($documentNumber: ID!) {
    customer(documentNumber: $documentNumber) {
      address {
        addressLocality
        addressRegion
        addressNumber
        complement
        district
        postalCode
        streetAddress
      }
      birthDate
      createdAt
      documentNumber
      email
      familyName
      gender
      givenName
      nationality
      nickName
      updatedAt
      whatsapp
    }
  }
`

export default GET_CUSTOMER_ID
